module.exports = __webpack_public_path__ + "assets/svg/Icons/32/settings-gray-13ccc6.svg";